module.exports = __webpack_public_path__ + "img/outofhome2.5d10302e.jpg";